import { createSlice  } from '@reduxjs/toolkit';
import axios from 'axios'

// this variable returns all the products
const initialState = {
    allProductsData: [],
    products: [],
    isGenderSwitched: false
};

export const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    // this function is used to read all the products
    readAllProducts:  (state)=>{
        //console.log("this is before fetch  products")
        state.allProductsData =  axios.get(process.env.REACT_APP_BACKEND_URL+'products/read')
        
    },

    storeProducts: (state,action)=>{
      state.products = action.payload
    },

    switchGender: (state,action)=>{
      state.isGenderSwitched = action.payload
      //console.log("isGenderSwitched: "+state.isGenderSwitched)
    }
  },
  
});

export const { readAllProducts, storeProducts, switchGender } = productSlice.actions;

export const selectAllProductsData = (state) =>state.product.allProductsData;

export const selectProductsData = (state) =>state.product.products;

export const selectisGenderSwitched = (state) =>state.product.isGenderSwitched;

export default productSlice.reducer;
